/* eslint-disable */
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/system/Unstable_Grid/Grid';
import { TextField } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Link from '@mui/material/Link';
import GlobalBackButton from 'views/utilities/BackButtonGlobal';
import { Link as RouterLink } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import BcConvertModal from 'views/Components/BcConvertModal';
import Spinner from 'views/Components/LoadingSinner';
import { handleCapture } from 'views/Components/BiometricDevices/BiometricCaptureDmt';
import ViewCustomerAuth from './DmtAuthComponents/BioAuthAnimation';
import { Alert } from 'antd';
import BiometricDevices from 'views/Components/BiometricDevices/BiometricDevices';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useCheckMerchantStatus, useProcessEkyc, useVerifyOtp, useResendOtp } from './hooks/useCreateCustomer';

const commonStyles = { m: 0 };

export default function CreateCustomer() {
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');
    const agentid = localStorage.getItem('id');
    const dmt_type = 1;
    const navigate = useNavigate();
    const location = useLocation();

    // UI State
    const [merchantModalOpen, setMerchantModalOpen] = useState(false);
    const [isBcConvertPending, setIsBcConvertPending] = useState(false);
    const [showResponse, setShowResponse] = useState(false);
    const [showFingerGif, setShowFingerGif] = useState(false);
    const [selectedDeviceName, setSelectedDeviceName] = useState('');

    // Data State
    const [captureData, setCaptureData] = useState('');
    const [OtpId, setOtpId] = useState('');
    const [kycId, setKycId] = useState('');

    const info =
        location?.state?.note ||
        'Customer Creation Charge - ₹10/- will be deducted from your main balance for each new DMT customer creation.';
    const initialValues = {
        CustomerName: '',
        phone: location?.state?.search || '',
        aadharno: '',
        OTPPin: ''
    };

    // --- React Query Hooks ---
    const { data: merchantData, isLoading: isCheckLoading } = useCheckMerchantStatus(agentid);
    const ekycMutation = useProcessEkyc((data) => {
        if (data?.success) {
            setShowResponse(true);
            setOtpId(data?.data?.OTPRequestID);
            setKycId(data?.data?.KYCRequestID);
        } else if (data?.ResponseCode === 2) {
            setKycId(data?.KYCRequestID);
        }
    });
    const verifyOtpMutation = useVerifyOtp((data) => {
        if (data?.success) navigate('/moneyTransfer1/viewCustomers');
    });
    const resendOtpMutation = useResendOtp((data) => {
        if (data?.success) setOtpId(data?.data?.otpRequestId);
    });

    const isLoading = ekycMutation.isPending || verifyOtpMutation.isPending || resendOtpMutation.isPending;

    // --- Effects ---
    useEffect(() => {
        if (merchantData) {
            const { agentType, isPending } = merchantData;
            setIsBcConvertPending(isPending);
            if (agentType === 'Merchant' || isPending || shouldshowEsign === 'true') {
                setMerchantModalOpen(true);
            }
        }
    }, [merchantData, shouldshowEsign]);

    // --- Validation ---
    const validationSchema = Yup.object().shape({
        CustomerName: Yup.string()
            .required('Required')
            .matches(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/, 'Invalid name'),
        phone: Yup.string()
            .required('Required')
            .matches(/^[6-9]\d{9}$/, 'Invalid mobile number. Must start with 6-9'),
        aadharno: Yup.string()
            .required('Required')
            .matches(/^\d{12}$/, 'Invalid Aadhaar'),
        OTPPin: Yup.string()
    });

    // --- Handlers ---
    const handleValueChange = (e, setFieldValue, field, regex, maxLen) => {
        const val = e.target.value;
        if (regex.test(val) || val === '') {
            if (!maxLen || val.length <= maxLen) setFieldValue(field, val);
        }
    };

    return (
        <div>
            <Box
                sx={{
                    width: '100%',
                    height: 'auto',
                    bgcolor: '#fff',
                    borderRadius: 2,
                    mb: 2,
                    p: { xs: '20px 10px', sm: 2 },
                    ...commonStyles
                }}
            >
                <Typography variant="h3">
                    <GlobalBackButton /> Create Customer
                </Typography>
                <Box sx={{ mt: '10px' }}>
                    <RouterLink to="/merchant-home" style={{ textDecoration: 'none', color: 'inherit' }}>
                        <HomeOutlined />
                    </RouterLink>
                    <Typography component="span" sx={{ mx: '10px' }}>
                        &gt;
                    </Typography>
                    <RouterLink to="/dmt/dmtTable" style={{ textDecoration: 'none', color: 'inherit' }}>
                        Domestic Money Transfer
                    </RouterLink>
                    <Typography component="span" sx={{ mx: '10px' }}>
                        &gt;
                    </Typography>
                    <Typography component="span">Create Customer</Typography>
                </Box>
            </Box>

            <Box sx={{ width: '100%', height: 'auto', bgcolor: '#fff', borderRadius: 2, p: { xs: '20px 10px', sm: 5 }, ...commonStyles }}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} enableReinitialize onSubmit={() => {}}>
                    {({ values, errors, touched, handleChange, handleBlur, setFieldValue, validateForm }) => {
                        const triggerEkyc = (pidData) => {
                            setFieldValue('OTPPin', '');
                            ekycMutation.mutate({
                                CustomerName: values.CustomerName,
                                CustomerMobileNo: values.phone,
                                agentId: '2',
                                AadharNo: values.aadharno,
                                Pid: pidData,
                                dmtType: dmt_type
                            });
                        };

                        const handleFingerAnimation = async () => {
                            const formErrors = await validateForm();
                            if (
                                Object.keys(formErrors).some((k) => ['CustomerName', 'phone', 'aadharno'].includes(k)) ||
                                !values.CustomerName ||
                                !values.phone ||
                                !values.aadharno
                            )
                                return;
                            setShowFingerGif(true);
                            setTimeout(() => {
                                handleCapture(selectedDeviceName, 'fino', (data) => {
                                    setShowFingerGif(false);
                                    if (data) {
                                        setCaptureData(data);
                                        triggerEkyc(data);
                                    }
                                });
                            }, 1000);
                        };

                        return (
                            <Form>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                required
                                                label="Customer Name"
                                                name="CustomerName"
                                                value={values.CustomerName}
                                                onBlur={handleBlur}
                                                onChange={(e) => handleValueChange(e, setFieldValue, 'CustomerName', /^[a-zA-Z\s]*$/, 25)}
                                                helperText={touched.CustomerName && errors.CustomerName}
                                                error={touched.CustomerName && Boolean(errors.CustomerName)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Mobile Number"
                                                variant="outlined"
                                                fullWidth
                                                required
                                                name="phone"
                                                value={values.phone}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                helperText={touched.phone && errors.phone}
                                                error={touched.phone && Boolean(errors.phone)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Aadhaar Number"
                                                variant="outlined"
                                                fullWidth
                                                required
                                                name="aadharno"
                                                value={values.aadharno}
                                                onBlur={handleBlur}
                                                onChange={(e) => handleValueChange(e, setFieldValue, 'aadharno', /^\d*$/, 12)}
                                                helperText={touched.aadharno && errors.aadharno}
                                                error={touched.aadharno && Boolean(errors.aadharno)}
                                            />
                                        </Grid>
                                        {showResponse && (
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="OTP Number"
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    name="OTPPin"
                                                    value={values.OTPPin}
                                                    onChange={(e) => handleValueChange(e, setFieldValue, 'OTPPin', /^\d*$/, 4)}
                                                />
                                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                                                    <Link
                                                        component="button"
                                                        variant="body2"
                                                        type="button"
                                                        onClick={() => {
                                                            setFieldValue('OTPPin', '');
                                                            resendOtpMutation.mutate({
                                                                CustomerName: values.CustomerName,
                                                                CustomerMobileNo: values.phone,
                                                                agentId: '2',
                                                                aadharNo: values.aadharno,
                                                                dmt_type
                                                            });
                                                        }}
                                                    >
                                                        Resend OTP
                                                    </Link>
                                                </Box>
                                            </Grid>
                                        )}
                                    </Grid>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                        {!showResponse ? (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="medium"
                                                fullWidth
                                                disabled={!values.CustomerName || !values.aadharno}
                                                onClick={handleFingerAnimation}
                                            >
                                                {isLoading ? 'Loading' : 'Submit'}
                                            </Button>
                                        ) : (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="medium"
                                                fullWidth
                                                disabled={!values.CustomerName || !values.aadharno || !values.OTPPin}
                                                onClick={() =>
                                                    verifyOtpMutation.mutate({
                                                        CustomerName: values.CustomerName,
                                                        CustomerMobileNo: values.phone,
                                                        agentId: '2',
                                                        OTPPin: values.OTPPin,
                                                        otpRequestId: OtpId,
                                                        kycRequestId: kycId,
                                                        dmtType: 1
                                                    })
                                                }
                                            >
                                                {isLoading ? 'Loading' : 'Verify Customer'}
                                            </Button>
                                        )}
                                    </Box>
                                </Box>
                            </Form>
                        );
                    }}
                </Formik>
                {info && <Alert message={info} type="info" showIcon style={{ mt: '20px' }} />}
            </Box>

            <ToastContainer />
            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    handleclose={() => setMerchantModalOpen(false)}
                    isPending={isBcConvertPending}
                    shouldshowEsign={shouldshowEsign}
                />
            )}
            <BiometricDevices onDeviceSelect={setSelectedDeviceName} />
            <Spinner loading={isCheckLoading || isLoading} />
            {showFingerGif && <ViewCustomerAuth />}
        </div>
    );
}
